import { render, staticRenderFns } from "./angsuran.vue?vue&type=template&id=cdd4932c&scoped=true"
import script from "./angsuran.vue?vue&type=script&lang=js"
export * from "./angsuran.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdd4932c",
  null
  
)

export default component.exports